// NG 2
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Route, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { AccountService } from '../../services/account.service';
import { SharedService } from '../../services/shared.service';

// APP
import { Account } from '../../viewmodel';

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    providers: [AccountService]
})
export class AccountComponent implements OnInit {
    account: any;

    pageError: any = [];
    pageSuccess: any = [];
    userAccount: Account;
    accountForm: FormGroup;
    userEmail: string = '';
    submitted: boolean = false;
    showSaveBotton: boolean = false;

    public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

    constructor(
        private router: Router,
        private _frmBuilder: FormBuilder,
        private authenticationService: AuthenticationService,
        private accountService: AccountService,
        private sharedService: SharedService) {
        this.userAccount = new Account();
    }

    ngOnInit() {

        var fullName = "";
        this.account = new Account();
        var user = this.sharedService.getJsonData("loggedInUser");
        this.getAccountByUserId(user.UserID);

        this.accountForm = this._frmBuilder.group({
            organization: [null, [Validators.required]],
            phone: [null, [Validators.required, Validators.pattern(/^\([1-9]\d{2}\)\s\d{3}-\d{4}|[1-9]\d{9}$/)]]
        })
    }

    getAccountByUserId(email) {
        this.accountService.getAccountByUserId(email)
            .subscribe(
                successResp => {

                    if (!successResp.Success) {
                        this.showError(successResp.StatusMessage);

                        if (successResp.StatusMessage.indexOf('SessionNotExists') !== -1) {
                            window.location.href = '/MIH/#/login?session=0';
                        }
                    }
                    else {
                        this.account = successResp.Result;
                        if (this.account == null)
                            this.showSaveBotton = false;
                        else {
                            this.userAccount.firstName = this.account.FirstName;
                            this.userAccount.lastName = this.account.LastName;
                            this.userAccount.fullName = this.account.FirstName + ' ' + this.account.LastName;
                            this.userAccount.email = this.account.UserID;
                            this.userAccount.organization = this.account.OrganizationName;
                            this.userAccount.phone = this.account.HomePhone;

                            if (this.userAccount.firstName == null || this.userAccount.firstName == 'N_A' || this.userAccount.firstName.trim() == ''
                                || this.userAccount.lastName == null || this.userAccount.lastName == 'N_A' || this.userAccount.lastName.trim() == ''
                                || this.userAccount.email == null || this.userAccount.email == '') {
                                this.updateProfile();
                            }

                            this.showSaveBotton = true;
                        }
                    }

                },
                error => {
                    this.showError(error.ExceptionMessage);
                })
    }

    //save(model, isValid)
    SaveAccount(): any {
        this.submitted = true;
        if (!this.accountForm.valid) {
            return false;
        }

        if (this.userAccount.organization == null || this.userAccount.organization.trim() == '') {
            this.userAccount.organization = '';
            return false;
        }

        if (this.userAccount.phone == null || this.userAccount.phone.trim() == '') {
            this.userAccount.phone = '';
            return false;
        }

        // Remove masking
        if (this.userAccount.phone) {
            this.userAccount.phone = this.userAccount.phone.replace(/\D/g, '');
        }

        this.accountService.saveAccount(this.userAccount)
            .subscribe(
                success => {
                    this.sharedService.setJsonData('account', this.userAccount);
                    this.showSuccess('Saved Successfully!');
                    let intervalId = setInterval(() => {
                        this.pageSuccess = [];
                    }, 2000);

                    this.router.navigate(["/home/save"]);
                },
                error => {
                    this.showError(error.statusText)
                })
    }

    updateProfile() {
        var profileUrlLink = '';

        this.authenticationService.getUpdateProfile()
            .subscribe(profileUrl => {
                profileUrlLink = profileUrl.d;
                window.location.href = profileUrlLink;
            });
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    showErrorAlert(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(msg);
        this.sharedService.processError(msg);
    }

    showSuccess(msg) {
        this.pageSuccess = []; this.pageError = [];
        this.pageSuccess.push(msg);
        this.sharedService.scroll();
    }

}

